import React from "react";
import {
  Card,
  Table,
  Typography,
  Space,
  Button,
  Tag,
  Dropdown,
} from "antd";
import { MoreOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

const actionMenu = {
  items: [
    { key: "edit", label: "Edit reverse DNS" },
    { key: "delete", label: "Delete", danger: true },
  ],
};

/* ---------------- PUBLIC NETWORK ---------------- */

const publicColumns = [
  {
    title: "PRIMARY IP",
    dataIndex: "ip",
    key: "ip",
    render: (ip) => <Text strong>{ip}</Text>,
  },
  {
    title: "PROTOCOL",
    dataIndex: "protocol",
    key: "protocol",
    render: (p) => <Tag>{p}</Tag>,
  },
  {
    title: "REVERSE DNS",
    dataIndex: "rdns",
    key: "rdns",
  },
  {
    key: "actions",
    align: "right",
    render: () => (
      <Dropdown menu={actionMenu} trigger={["click"]}>
        <Button type="text" icon={<MoreOutlined />} />
      </Dropdown>
    ),
  },
];

const publicData = [
  {
    key: "1",
    ip: "142.132.169.253",
    protocol: "IPv4",
    rdns: "static.253.169.132.142.clients.your-server.de",
  },
  {
    key: "2",
    ip: "2a01:4f8:1c1b:55a2::/64",
    protocol: "IPv6",
    rdns: "0 Entries",
  },
];

/* ---------------- COMPONENT ---------------- */

export default function Networking() {
  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      {/* PUBLIC NETWORK */}
      <Card>
        <Title level={5}>
          PUBLIC NETWORK <Tag color="green">Active</Tag>
        </Title>

        <Table
          columns={publicColumns}
          dataSource={publicData}
          pagination={false}
          size="middle"
        />

        <Button disabled style={{ marginTop: 16 }}>
          Disable public network
        </Button>
      </Card>

      {/* PRIVATE NETWORK */}
      <Card>
        <Title level={5}>PRIVATE NETWORK</Title>

        <Paragraph>
          Private IPs identify your server in a network. Private
          networks allow your servers to talk to each other over
          a dedicated link.
        </Paragraph>

        <Text type="secondary">
          There is no private IP assigned to this server.
        </Text>

        <Space style={{ marginTop: 16 }}>
          <Button danger type="primary">
            Create network
          </Button>
          <Button disabled>Attach to network</Button>
        </Space>
      </Card>

      {/* FLOATING IPS */}
      <Card>
        <Title level={5}>FLOATING IPS</Title>

        <Paragraph>
          Floating IPs help you to create highly flexible setups.
          A Floating IP can be assigned and reassigned to any
          server at any time as long as they are in the same
          network zone.
        </Paragraph>

        <Paragraph>
          Floating IPs need to be configured on your server in
          order to work. You can find a short example
          configuration in our Docs.
        </Paragraph>

        <Text type="secondary">
          There is no Floating IP assigned to this server.
        </Text>

        <Space style={{ marginTop: 16 }}>
          <Button danger type="primary">
            Add Floating IP
          </Button>
          <Button disabled>Assign Floating IP</Button>
        </Space>
      </Card>
    </Space>
  );
}
